var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"qmodii-app",attrs:{"id":_vm.c_qmComponentName,"dark":_vm.c_qmComponentProps.dark}},[_c('v-content',{staticClass:"qmodii-content"},[_c(_vm.c_qmComponentName,_vm._b({tag:"component",attrs:{"qmWMID":_vm.c_qmWMID}},'component',_vm.c_qmComponentProps,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }